import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { orgDetails } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/billingSlice";
const UseFetchGetOrganizationDetails = () => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["orgDetails"],
        queryFn: () => orgDetails(),
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
        // staleTime: Infinity, // Keep the data fresh indefinitely
       
        refetchOnWindowFocus: false, // Don't refetch when window regains focus
        refetchOnReconnect: false, // Don't refetch when reconnecting
        refetchOnMount: false, // Don't refetch on component mount
    });
};

export default UseFetchGetOrganizationDetails;
